import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useCallback, useMemo } from 'react';
var css = {
  "title": "oalp-18LOe",
  "bannerContainer": "oalp-1iLti",
  "crossIconContainer": "oalp-3dSqE",
  "cardContainer": "oalp-35h3Y"
};
import { compose } from 'redux';
import { connect } from 'react-redux';
import { updateBuyerIntentFilter as _updateBuyerIntentFilter, updateBuyerIntentEvalState as _updateBuyerIntentEvalState, updateCarCount as _updateCarCount } from "../../Store/Actions/buyerIntent";
import { Filters } from "../../Constants/filters";
import CTA from "../../Components/CTA/CTA";
import { Icon } from 'panamera-react-ui';
import PriceEmi from "../../Components/PriceEmi/PriceEmi";
import FilterTile from "../../Components/FilterTile/FilterTile";
import BrandSelection from "../../Components/BrandSelection/BrandSelection";
import StaticItem from "../../Components/StaticItem/StaticItem";
import { getMinMaxRange, getSelectedRangeFilter } from "../../Helpers/filter";
import { Link } from 'react-router-dom';
import { withRouter } from "../../Helpers/withRouter";
import DependencyManager from "../../DependencyManager";
import { selectFrom, trackingEvents, disabledCardStyle, selectedCardStyle, cardStyle, cardTitle, bodyTypeDisabledCardStyle, bodyTypeSelectedCardStyle, bodyTypeCardStyle } from "../../Constants/buyerIntent";
import { parseFilters } from "../../Helpers/buyerIntent";
import UserSession from "../../Utils/UserSession";
import { FilterInitialState } from "../../Store/Reducers/buyerIntent";
import withConfig from "../../ComponentDependency/withConfig";
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import { getAcquisitionChannelTrackingValues } from "../../Utils/LayoutHelper";
var BuyerIntentWidget = function BuyerIntentWidget(_ref) {
  var name = _ref.name,
    buyerIntent = _ref.buyerIntent,
    updateBuyerIntentFilter = _ref.updateBuyerIntentFilter,
    updateBuyerIntentEvalState = _ref.updateBuyerIntentEvalState,
    data = _ref.data,
    metadata = _ref.metadata,
    currentCarCount = _ref.currentCarCount,
    updateCarCount = _ref.updateCarCount,
    router = _ref.router,
    config = _ref.config,
    track = _ref.track,
    origin = _ref.origin;
  var cta = data.cta,
    nextState = data.nextState,
    prevState = data.prevState,
    content = data.content,
    title = data.title,
    banner = data.banner,
    stepName = data.stepName,
    icon = data.icon,
    prevStep = data.prevStep,
    tabsButtons = data.tabsButtons,
    brandListTitle = data.brandListTitle,
    nextStep = data.nextStep,
    _data$priceTabTitle = data.priceTabTitle,
    priceTabTitle = _data$priceTabTitle === void 0 ? '' : _data$priceTabTitle,
    _data$emiTabTitle = data.emiTabTitle,
    emiTabTitle = _data$emiTabTitle === void 0 ? '' : _data$emiTabTitle;
  var _content$years = content.years,
    years = _content$years === void 0 ? [] : _content$years,
    _content$bodyTypes = content.bodyTypes,
    bodyTypes = _content$bodyTypes === void 0 ? [] : _content$bodyTypes,
    _content$totalCount = content.totalCount,
    totalCount = _content$totalCount === void 0 ? 0 : _content$totalCount,
    _content$popularBrand = content.popularBrands,
    popularBrands = _content$popularBrand === void 0 ? [] : _content$popularBrand,
    _content$brandList = content.brandList,
    brandList = _content$brandList === void 0 ? [] : _content$brandList;
  var _ref2 = metadata || {},
    _ref2$showBackButton = _ref2.showBackButton,
    showBackButton = _ref2$showBackButton === void 0 ? false : _ref2$showBackButton;
  var _buyerIntent$filters = buyerIntent.filters,
    appliedFilters = _buyerIntent$filters === void 0 ? {} : _buyerIntent$filters;
  var image = banner.image,
    bannerTitle = banner.title,
    bannerSubtitle = banner.subtitle;
  var _useState = useState(_defineProperty({}, stepName, appliedFilters[stepName])),
    _useState2 = _slicedToArray(_useState, 2),
    appliedFiltersLocal = _useState2[0],
    setAppliedFiltersLocal = _useState2[1];
  var dependencyFunction = DependencyManager.getDependency('functions');
  var buyOrganicLandingPageUrl = config && config.get('landingPageRoutes', 'buy-organic') || '/';
  var isOlxMobbi = config === null || config === void 0 ? void 0 : config.get('isOlxMobbi');
  var formattedBannerTitle = useMemo(function () {
    return Object.assign(Object.assign({}, bannerTitle), {
      text: bannerTitle.text.replace('$autosCount$', currentCarCount ? currentCarCount.toString() : '0')
    });
  }, [bannerTitle, currentCarCount]);
  var _useState4 = useState(Filters.price),
    _useState5 = _slicedToArray(_useState4, 2),
    subStep = _useState5[0],
    setSubStep = _useState5[1];
  useEffect(function () {
    if (!appliedFiltersLocal[stepName]) {
      updateCarCount(totalCount);
    }
  }, []);
  useEffect(function () {
    var _ref3;
    updateBuyerIntentFilter(stepName === Filters.price_emi ? (_ref3 = {}, _defineProperty(_ref3, Filters.price, ''), _defineProperty(_ref3, Filters.emi, ''), _ref3) : _defineProperty({}, stepName, ''));
  }, [stepName, updateBuyerIntentFilter]);
  var discardAllFilters = useCallback(function () {
    var updatedValue = {};
    switch (stepName) {
      case Filters.make:
      case Filters.year:
      case Filters.bodyType:
        {
          updatedValue[stepName] = '';
          break;
        }
      case Filters.price_emi:
        updatedValue[Filters.price] = '';
        updatedValue[Filters.emi] = '';
    }
    updateCarCount(totalCount);
    updateBuyerIntentFilter(updatedValue);
  }, [stepName, totalCount, updateBuyerIntentFilter, updateCarCount]);
  function handleSkip() {
    discardAllFilters();
    updateBuyerIntentEvalState(nextState);
  }
  var getTrackingInfo = useMemo(function () {
    return Object.assign({
      origin: origin
    }, getAcquisitionChannelTrackingValues());
  }, [origin]);
  function handleNext() {
    var filterState = appliedFiltersLocal;
    if (nextStep === null) {
      UserSession.setAdundanceCount(currentCarCount);
      var url = dependencyFunction.buildURL({
        category: {
          id: config && config.get('adpvAuto', 'carCategory')
        },
        params: {
          filter: parseFilters(Object.assign(Object.assign({}, appliedFilters), appliedFiltersLocal))
        }
      }, {}, !!isOlxMobbi);
      router === null || router === void 0 ? void 0 : router.push(url);
      filterState = FilterInitialState;
      if (track) {
        var select_from = '';
        select_from = Object.keys(appliedFilters).reduce(function (acc, filterName) {
          if (appliedFilters[filterName]) {
            return acc ? "".concat(acc, "_").concat(selectFrom[filterName]) : selectFrom[filterName];
          }
          return acc;
        }, '');
        if (appliedFiltersLocal[subStep]) {
          select_from = select_from ? "".concat(select_from, "_").concat(selectFrom[subStep]) : selectFrom[subStep];
        }
        var additionalInfo = {
          select_from: select_from,
          result_count: currentCarCount
        };
        track(trackingEvents.searchListings, Object.assign(Object.assign({}, getTrackingInfo), additionalInfo));
      }
    } else {
      updateBuyerIntentEvalState(nextState);
    }
    updateBuyerIntentFilter(filterState);
  }
  function handleBackButton() {
    discardAllFilters();
    updateBuyerIntentEvalState(prevState);
    if (prevStep === null) {
      router === null || router === void 0 ? void 0 : router.push(buyOrganicLandingPageUrl);
    }
  }
  var parsedCTAs = useMemo(function () {
    var shouldDisableNextButton = function shouldDisableNextButton() {
      var shouldDisable = false;
      switch (stepName) {
        case Filters.make:
        case Filters.year:
        case Filters.bodyType:
          shouldDisable = !appliedFiltersLocal[stepName];
          break;
      }
      return shouldDisable;
    };
    if (cta && cta.buttons) {
      return cta.buttons.map(function (btn) {
        return btn.name === 'next' ? Object.assign(Object.assign({}, btn), {
          disabled: shouldDisableNextButton()
        }) : btn;
      });
    }
    return [];
  }, [cta, stepName, appliedFiltersLocal]);
  var getActionHandler = function getActionHandler(action) {
    switch (action) {
      case 'skip':
        return handleSkip;
      case 'next':
        return handleNext;
      case 'backButton':
        return handleBackButton;
      default:
        return function () {
          return null;
        };
    }
  };
  var getMinMaxValue = useCallback(getMinMaxRange, []);
  function handleFilterClick(filter) {
    var filterType = appliedFiltersLocal[stepName] || '';
    var updatedValue = Object.assign({}, appliedFiltersLocal);
    var newCount = 0;
    var _filter$range = filter.range,
      _filter$range2 = _filter$range === void 0 ? {} : _filter$range,
      _filter$range2$min = _filter$range2.min,
      min = _filter$range2$min === void 0 ? null : _filter$range2$min,
      _filter$range2$max = _filter$range2.max,
      max = _filter$range2$max === void 0 ? null : _filter$range2$max;
    var updatedFilterValue = '';
    switch (stepName) {
      case Filters.bodyType:
      case Filters.make:
        {
          var filterVal = filterType.split(',');
          var _filter$value = filter.value,
            value = _filter$value === void 0 ? '' : _filter$value;
          var idx = filterVal.indexOf(value);
          if (!filterType) {
            newCount = filter.count;
            updatedValue[stepName] = value;
          } else if (idx === -1) {
            updatedValue[stepName] = updatedValue[stepName] ? "".concat(updatedValue[stepName], ",").concat(value) : value;
            newCount = currentCarCount + filter.count;
          } else {
            filterVal.splice(idx, 1);
            updatedValue[stepName] = filterVal.reduce(function (acc, fv) {
              return acc && fv ? "".concat(acc, ",").concat(fv.toLowerCase()) : fv.toLowerCase();
            }, '');
            newCount = currentCarCount - filter.count;
          }
          break;
        }
      case Filters.year:
        {
          var prevSelectedFilterValue = buyerIntent && buyerIntent.filters && buyerIntent.filters[stepName] || '';
          var _getMinMaxValue = getMinMaxValue(prevSelectedFilterValue),
            prevMin = _getMinMaxValue.min,
            prevMax = _getMinMaxValue.max;
          var prevSelectedFilter = getSelectedRangeFilter(years, prevMin, prevMax);
          newCount = prevSelectedFilter.count ? currentCarCount - prevSelectedFilter.count : currentCarCount;
          newCount = filter.count;
          var _filter$range3 = filter.range,
            range = _filter$range3 === void 0 ? {} : _filter$range3;
          var newMin = range.min,
            newMax = range.max;
          updatedValue[stepName] = "year_min=".concat(newMin, "&year_max=").concat(newMax);
          break;
        }
      case Filters.price_emi:
        updatedValue[Filters.price] = '';
        updatedValue[Filters.emi] = '';
        if (min && max) {
          updatedFilterValue = "".concat(subStep, "_min=").concat(min, "&").concat(subStep, "_max=").concat(max);
        } else if (min) {
          updatedFilterValue = "".concat(subStep, "_min=").concat(min);
        } else if (max) {
          updatedFilterValue = "".concat(subStep, "_max=").concat(max);
        }
        updatedValue[subStep] = updatedFilterValue;
        newCount = filter.count;
        break;
      default:
        break;
    }
    newCount = newCount === 0 ? totalCount : newCount;
    if (track) {
      var select_from = '';
      if (stepName === Filters.price_emi) {
        select_from = selectFrom[subStep];
      } else {
        select_from = selectFrom[stepName];
      }
      var additionalFields = {
        select_from: select_from,
        result_count: newCount,
        chosen_option: filter.name
      };
      track(trackingEvents.widgetFilters, Object.assign(Object.assign({}, getTrackingInfo), additionalFields));
    }
    updateCarCount(newCount);
    setAppliedFiltersLocal(updatedValue);
  }
  var getFormattedYearData = useMemo(function () {
    return years && Array.isArray(years) && years.map(function (filter) {
      var name = filter.name,
        count = filter.count;
      var style = {};
      var selectedValue = appliedFiltersLocal[stepName];
      var _filter$range4 = filter.range,
        range = _filter$range4 === void 0 ? {} : _filter$range4;
      var _getMinMaxRange = getMinMaxRange(selectedValue),
        min = _getMinMaxRange.min,
        max = _getMinMaxRange.max;
      style = range.min === min && range.max === max ? selectedCardStyle : cardStyle;
      if (count <= 0) {
        style = disabledCardStyle;
      }
      return {
        title: {
          text: name,
          style: style
        }
      };
    }) || [];
  }, [years, stepName, appliedFiltersLocal]);
  var getFormattedBodyTypeData = useMemo(function () {
    return bodyTypes && Array.isArray(bodyTypes) && bodyTypes.map(function (filter) {
      var name = filter.name,
        count = filter.count,
        icon_url = filter.icon_url,
        value = filter.value;
      var style = {};
      var selectedValue = appliedFiltersLocal[stepName];
      var filterVal = selectedValue.split(',');
      var idx = filterVal.indexOf(value);
      style = idx > -1 ? bodyTypeSelectedCardStyle : bodyTypeCardStyle;
      if (count <= 0) {
        style = bodyTypeDisabledCardStyle;
      }
      return {
        title: {
          text: name,
          style: cardTitle
        },
        image: {
          url: icon_url,
          style: style
        }
      };
    }) || [];
  }, [bodyTypes, stepName, appliedFiltersLocal]);
  var getCurrentStepView = function getCurrentStepView() {
    switch (stepName) {
      case Filters.year:
        return /*#__PURE__*/React.createElement(FilterTile, {
          filterList: years,
          clickHandler: handleFilterClick,
          parsedData: getFormattedYearData
        });
      case Filters.bodyType:
        return /*#__PURE__*/React.createElement(FilterTile, {
          filterList: bodyTypes,
          clickHandler: handleFilterClick,
          parsedData: getFormattedBodyTypeData,
          className: css.cardContainer
        });
      case Filters.price_emi:
        return /*#__PURE__*/React.createElement(PriceEmi, {
          tabsButtons: tabsButtons,
          content: content,
          handleFilterClick: handleFilterClick,
          subStep: subStep,
          setSubStep: setSubStep,
          discardAllFilters: discardAllFilters,
          tabTitle: subStep === Filters.price ? priceTabTitle : emiTabTitle,
          widgetKey: name
        });
      case Filters.make:
        return /*#__PURE__*/React.createElement(BrandSelection, {
          appliedFilters: appliedFiltersLocal.make,
          brands: popularBrands,
          metadata: metadata,
          name: name,
          list: brandList,
          icon: icon,
          handleFilterClick: handleFilterClick,
          title: brandListTitle
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.bannerContainer
  }, /*#__PURE__*/React.createElement(StaticItem, {
    widgetName: name,
    image: image,
    title: formattedBannerTitle,
    subtitle: bannerSubtitle
  })), /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, showBackButton && /*#__PURE__*/React.createElement("span", {
    onClick: handleBackButton
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: 'arrowLeft',
    size: 24
  })), title && /*#__PURE__*/React.createElement("div", {
    style: title.style
  }, title.text)), getCurrentStepView(), cta && parsedCTAs && /*#__PURE__*/React.createElement("div", {
    style: cta.style
  }, parsedCTAs.map(function (button, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: "widget_".concat(name, "_cta_").concat(idx),
      button: button,
      widgetKey: name,
      "data-aut-id": "".concat(name, "_cta_").concat(idx),
      handleOnClick: getActionHandler(button.name)
    });
  })), /*#__PURE__*/React.createElement(Link, {
    className: css.crossIconContainer,
    to: buyOrganicLandingPageUrl
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: 'cross',
    size: 24,
    color: 'white'
  })));
};
export var mapStateToProps = function mapStateToProps(state) {
  return {
    buyerIntent: state.buyerIntent,
    currentCarCount: state.buyerIntent && state.buyerIntent.carCount,
    origin: getTrackingOrigin(state, null)
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateBuyerIntentFilter: function updateBuyerIntentFilter(filter) {
      return dispatch(_updateBuyerIntentFilter(filter));
    },
    updateBuyerIntentEvalState: function updateBuyerIntentEvalState(evalState) {
      return dispatch(_updateBuyerIntentEvalState(evalState));
    },
    updateCarCount: function updateCarCount(count) {
      return dispatch(_updateCarCount(count));
    }
  };
};
export default compose(withRouter, withConfig, connect(mapStateToProps, mapDispatchToProps))(BuyerIntentWidget);